import type { IState } from "country-state-city/lib/interface";
import State from "country-state-city/lib/state";
import type { JSX } from "react";
import { useMemo } from "react";
import type { GenericSelectItem } from "@/common/types/types";
import { Combobox } from "@/components/ui/Combobox";

interface Props {
  placeholder?: string;
  onValueChange: ({ value, label }: GenericSelectItem) => void;
  value?: string;
  countryCode: string;
}

export const StateCombobox = (props: Props): JSX.Element => {
  const states = useMemo(() => {
    return State.getStatesOfCountry(props.countryCode).map((state: IState) => ({
      value: state.isoCode,
      label: state.name,
    }));
  }, [props.countryCode]);

  return (
    <Combobox
      items={states}
      placeholder={props.placeholder}
      value={props.value}
      onValueChange={(value) => {
        props.onValueChange({ label: value.label, value: value.value });
      }}
    />
  );
};
